import { render, staticRenderFns } from "./PurchaseOrderHistory.vue?vue&type=template&id=4d3bc778&scoped=true&"
import script from "./PurchaseOrderHistory.vue?vue&type=script&lang=ts&"
export * from "./PurchaseOrderHistory.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseOrderHistory.vue?vue&type=style&index=0&id=4d3bc778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3bc778",
  null
  
)

export default component.exports